<template>
    <v-hover v-if="product">
        <template v-slot="{ hover }">
            <v-card outlined :elevation="hover ? 0: 0" style="position: relative" class="border-transparent basket-product-width py-0 px-4">
                <v-btn icon class="close-icon">
                    <v-icon size="16" @click="$emit('delete-product', product.id)">close</v-icon>
                </v-btn>
                <v-card-text class="pa-0 pa-md-4">
                    <!--Mobile version-->
                    <v-row class="hidden-lg-and-up pa-0">
                        <v-col sm="12" class="px-0">
                            <div class="d-flex">
                                <div class="d-flex align-center">
                                    <router-link :to="link" class="pr-4">
                                        <v-img :src="imageThumbSrc" contain class="basket-product-image" v-if="imageSrc"></v-img>
                                        <span class="caption" v-if="!imageSrc">Product Image</span>
                                    </router-link>
                                </div>
                                <div>
                                    <div class="body-1 font-weight-bold">{{ product.productName }}</div>
                                    <quantity-select
                                            :id="product.id"
                                            :order-data="product.pack"
                                            :price="product.price.priceUah"
                                            :discount-price="discountPrice"
                                            :total-discount="totalDiscount"
                                            :seller-id="product.sellerID"
                                            @value-change="orderChange"
                                    ></quantity-select>
                                </div>
                            </div>
                            <v-row class="pa-0">
                                <v-col cols="12" md="12" class="py-0 pa-md-0 caption">
                                    <div class="font-weight-light font-italic pr-3">
                                        {{ $t('packing') }}: <span class="grey--text">{{ realizationForm }}</span>.
                                    </div>
                                    <div class="font-weight-light font-italic pr-3" v-if="minOrder">
                                        {{ $t('minOrder') }}: <span class="grey--text">{{ minOrder }}</span>.
                                    </div>
                                    <div class="font-weight-light font-italic pr-3">
                                        <span class="grey--text">
                                            {{ product.price.withNds ? $t('priceWithNds') : $t('priceWithoutNds') }}
                                        </span>.
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <!--Desktop version-->
                    <v-row class="hidden-md-and-down">
                        <v-col sm="1" md="2" class="d-flex justify-start pt-4 pl-4 pa-md-0 pt-md-4">
                            <router-link :to="link">
                                <v-img :src="imageThumbSrc" contain class="basket-product-image" v-if="imageSrc"></v-img>
                                <span class="caption" v-if="!imageSrc">Product Image</span>
                            </router-link>
                        </v-col>
                        <v-col sm="11" md="10" class="py-0">
                            <v-row>
                                <v-col cols="12" md="12" class="px-0 py-0">
                                    <div class="py-2 py-md-0 text-center text-md-left body-1 font-weight-bold">{{ product.productName }}</div>
                                </v-col>
                                <v-col cols="12" md="12" class="pa-0 pt-4">
                                    <quantity-select
                                            :id="product.id"
                                            :order-data="product.pack"
                                            :price="priceWithProductDiscount"
                                            :discount-price="discountPrice"
                                            :total-discount="totalDiscount"
                                            :seller-id="product.sellerID"
                                            @value-change="orderChange"
                                    ></quantity-select>
                                </v-col>
                                <v-col cols="12" md="12" class="pa-0 caption">
                                    <div class="font-weight-light font-italic pr-3">
                                        {{ $t('packing') }}: <span class="grey--text">{{ realizationForm }}</span>.
                                    </div>
                                    <div class="font-weight-light font-italic pr-3" v-if="minOrder">
                                        {{ $t('minOrder') }}: <span class="grey--text">{{ minOrder }}</span>.
                                    </div>
                                    <div class="font-weight-light font-italic pr-3">
                                        <span class="grey--text">
                                            {{ product.price.withNds ? $t('priceWithNds') : $t('priceWithoutNds') }}
                                        </span>.
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
            </v-card>
        </template>
    </v-hover>
</template>

<script>
    import QuantitySelect from './QuantitySelect'
    import Thumbs from '../../../../app-front/mixins/ThumbsProducts';

    export default {
        name: "ProductCard",
        props:['product'],
        mixins: [Thumbs],
        components: {QuantitySelect},
        data() {
            return {
                calculatedPrice: null,
                discountPrice: null,
                totalDiscount: null
            }
        },
        computed: {
            orderData() {
                return this.$store.state.order.inProcess.find(item => item.sellerID ===  this.product.sellerID);
            },
            orderPriceSummary() {
                const orderData = this.$store.state.order.inProcess.find(item => item.sellerID ===  this.product.sellerID);

                if(!orderData) return null;

                return orderData.priceSummary;
            },
            orderPaymentWay() {
                return this.orderData ? this.orderData.paymentWay : null;
            },
            orderDate() {
                const orderData = this.$store.state.order.inProcess.find(item => item.sellerID ===  this.product.sellerID);

                if(!orderData) return null;

                return orderData.date;
            },
            activeDiscounts() {
                return this.orderData ? this.orderData.discounts : [];
            },
            priceCss() {
                return this.discountPrice ? 'text-decoration-line-through' : '';
            },
            imageSrc() {
                return this.product.images[0] || null;
            },
            imageThumbSrc() {
                if (!this.product.images.length) {
                    return '/images/default-product.png';
                }

                return this.getProductThumb(this.product.images[0], 160);
            },
            minOrder() {
                if (!this.packData.minValue) return '';

                if(this.packData.minPackName) {
                    return `${this.packData.minPackName.toLowerCase()} (${this.packData.minValue} ${this.packData.packName.toLowerCase()})`;
                } else {
                    return `${this.packData.minValue} ${this.packData.packName.toLowerCase()}`;
                }
            },
            packData() {
                return this.product.pack || {};
            },
            priceWithProductDiscount() {
                return (this.product.discount === 0) ? this.product.price.priceUah : this.product.price.priceUah * (1 - this.product.price.discount/100);
            },
            productID() {
                return this.product.productId || null;
            },
            realizationForm() {
                if (!this.packData) return '';

                return `${this.packData.packName.toLowerCase()} ${this.packData.value} ${this.packData.unitName}`;
            },
            link() {
                return {
                    name: 'product',
                    params: {
                        parentCategory: this.product.parentCategorySysName,
                        category: this.product.categorySystemName,
                        sysNameWithId: `${ this.product.systemName }-${ this.product.id }`
                    }
                }
            },
        },
        methods: {
            orderChange(data) {
                const emitData = {
                    id: this.product.id,
                    sellerID: this.product.sellerID,
                    selfShipment: this.product.selfShipment,
                    price: data.price ? this.product.price.priceUah : null,
                    discount: this.product.price.discount,
                    quantity: parseFloat(data.quantity),
                    calculatedPrice: data.price,
                };
                this.$emit('order-change', emitData);
            },
            setValues() {
                const orderData = this.$store.state.order.inProcess.find(item => item.sellerID ===  this.product.sellerID);
                if(!orderData) {
                    this.resetPrices();
                } else {
                    const productData = orderData.products.find(item => item.id === this.product.id);

                    if(!productData) {
                        this.resetPrices();
                    } else {
                        this.calculatedPrice = productData.calculatedPrice;

                        if(orderData.totalDiscount) {
                            this.totalDiscount = orderData.totalDiscount;
                            this.discountPrice = this.calculatedPrice * (1 - this.totalDiscount / 100);
                        } else {
                            this.totalDiscount = null;
                            this.discountPrice = null;
                        }
                    }
                }
            },
            resetPrices() {
                this.calculatedPrice = null;
                this.discountPrice = null;
                this.totalDiscount = null;
            }
        },
        watch: {
            orderPriceSummary () {
                this.setValues();
            },
            activeDiscounts() {
                this.setValues()
            }
        }
    }
</script>

<style scoped>
    .basket-product-width {
        width: 95%;
    }
    .basket-product-image {
        max-width: 100px;
    }
    .close-icon {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .text-decoration-line-through {
        text-decoration: line-through!important;;
    }
    @media screen and (max-width: 800px){
        .basket-product-image {
            max-width: 80px;
        }
        .basket-product-width {
            width: 90%;
        }
    }
</style>
